import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import OurCommitmentContainer from 'containers/OurCommitmentContainer';
import { openModal } from 'state/actions/app';
import { MODAL_TYPES } from 'state/constants';
import { parseQueryString } from 'utils/Url';

const OurCommitmentController = class {
  static mountOurCommitmentContainer(store) {
    ReactDOM.render(
      <Provider store={store}>
        <OurCommitmentContainer />
      </Provider>,
      document.getElementById('our-commitment-modal')
    );
  }

  static checkURL(store) {
    const urlQuery = parseQueryString();
    if (urlQuery.voted) {
      store.dispatch(openModal(MODAL_TYPES.OUR_COMMITMENT));
    }
  }

  static triggerAnimationsOnEnterView() {
    const flowers = document.querySelector('.OurCommitment__flowers');
    const heroGlobe = document.querySelector('.OurCommitment__hero-globe-container');

    const observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (
          entry.intersectionRatio > 0 &&
          !entry.target.className.includes(`${entry.target.classList[0]}--animated`)
        ) {
          entry.target.classList.add(`${entry.target.classList[0]}--animated`);
        }
      });
    });

    observer.observe(flowers);
    observer.observe(heroGlobe);
  }

  static init = async store => {
    OurCommitmentController.checkURL(store);
    OurCommitmentController.mountOurCommitmentContainer(store);
    OurCommitmentController.triggerAnimationsOnEnterView();
  };
};

export default OurCommitmentController;
